import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import type AlertTriggeredJournalEvent from "parog-web/models/alert-triggered-journal-event";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
//---- Automatically generated, don't update this part ----

type MrcStageUpdateStringEnum = "yes" | "no" | "later" | "notEvaluated";

type TlsSuggestionStringEnum = "yes" | "no" | "later" | "notEvaluated";

/**
 * A journal event to track decisions taken in relation to alerts that affect patients' mrc stage
 */
export default class MrcStageEvaluatedJournalEvent extends JournalEvent {
  static override type = "mrc-stage-evaluated-journal-event";

  @attr("string") declare mrcStageUpdate: MrcStageUpdateStringEnum;

  @attr("string") declare tlsSuggestion: TlsSuggestionStringEnum;

  @belongsTo("alert-triggered-journal-event", {
    async: false,
    inverse: "mrcStageEvaluatedJournalEvent"
  })
  declare alertTriggeredJournalEvent: AlertTriggeredJournalEvent;

  static override validations(intl: IntlService) {
    return {
      mrcStageUpdate: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.mrc-stage-evaluated-journal-event.mrc-stage-update"
          )
        }),
        validateInclusion({
          list: ["yes", "no", "later", "notEvaluated"],
          description: intl.t(
            "validations.mrc-stage-evaluated-journal-event.mrc-stage-update"
          )
        })
      ],
      tlsSuggestion: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.mrc-stage-evaluated-journal-event.tls-suggestion"
          )
        }),
        validateInclusion({
          list: ["yes", "no", "later", "notEvaluated"],
          description: intl.t(
            "validations.mrc-stage-evaluated-journal-event.tls-suggestion"
          )
        })
      ],
      alertTriggeredJournalEvent: validatePresence({
        presence: true,
        description: intl.t(
          "validations.mrc-stage-evaluated-journal-event.alert-triggered-journal-event"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.mrc-stage-evaluated-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "mrc-stage-evaluated-journal-event": MrcStageEvaluatedJournalEvent;
  }
}
